import SideBar from './SideBar'
import Article from './Article'
import Placeholder from './Placeholder'

const Components = {
    'side_bar': SideBar,
    'article': Article,
}

const DynamicComponent = ({ blok , full ,published_at, slug}) => {
    
    if (typeof Components[blok.component] !== 'undefined') {
        const Component = Components[blok.component]
        return <Component blok = { blok } full={ full } published_at={published_at} slug={slug}/>
    }
    return <Placeholder componentName = { blok.component } />
}

export default DynamicComponent
